import Flux from 'lib/flux';
import BookingDetailsConstants from 'constants/booking_details';

export default Flux.createActionCreator({
  showDates() {
    this.dispatchAction(BookingDetailsConstants.SHOW_DATES);
  },

  datesShown() {
    this.dispatchAction(BookingDetailsConstants.DATES_SHOWN);
  },

  showForm() {
    this.dispatchAction(BookingDetailsConstants.SHOW_FORM);
  },
});
